function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#chevron_svg__clip0_1030_1215)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 9a1 1 0 011.71-.71l5.29 5.3 5.29-5.3a1.004 1.004 0 011.42 1.42l-6 6a.997.997 0 01-1.095.219.999.999 0 01-.325-.22l-6-6A1 1 0 015 9z",
  fill: "#747474"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "chevron_svg__clip0_1030_1215"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgChevron;